import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
// import { Link } from 'react-router-dom';
import { Card, CardBody, Input } from "reactstrap";
import SimpleBar from "simplebar-react";
import TravelLinkService from "../../services/TravelLinkService/TravelLinkService";

// //SimpleBar
// import SimpleBar from "simplebar-react";

// //import images
// import image2 from "../../assets/images/users/avatar-2.jpg";
// import image3 from "../../assets/images/users/avatar-3.jpg";
// import image5 from "../../assets/images/users/avatar-5.jpg";
const SearchResultCard = ({ item, onViewClick }) => {
  return (
    <div className="card mb-3 shadow-sm border-0">
      <div className="row g-0 align-items-center">
        {/* Image Section */}
        <div className="col-3 d-flex justify-content-center">
          <img
            src={item?.banner_image_url || ""}
            alt="Package"
            className="img-fluid rounded-start"
            style={{ width: "100px", height: "100px", objectFit: "contain" }}
          />
        </div>

        {/* Content Section */}
        <div className="col-7">
          <div className="card-body py-2">
            <h6 className="fs-12 mb-1">
              {item?.name || "Unnamed Package"}
            </h6>
            <p className="card-text small text-muted mb-1">
              Country: {item?.country?.name || "N/A"}
            </p>
            <p className="card-text small text-muted mb-1">
              Duration: {item?.duration || "N/A"}
            </p>
            <p className="card-text small text-muted">
              Trip: {item?.trip || "N/A"}
            </p>
          </div>
        </div>

        {/* Button Section */}
        <div className="col-2 d-flex justify-content-end align-items-center p-3">
          <Link
            to={`/packages/${item?.slug || "#"}`}
            className="btn btn-sm btn-outline-info"
            onClick={() => onViewClick(item?.id)}
          >
             View
          </Link>
        </div>
      </div>
    </div>
  );
};

const SearchOption = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  const fetchData = useCallback(async (query) => {
    if (!query.trim()) {
      setSearchResults([]);
      return;
    }

    try {
      const response = await TravelLinkService.getSearch(query);
      setSearchResults(response || []);
    } catch (error) {
      console.error("Search error:", error);
      setSearchResults([]);
    }
  }, []);

  // Debounced search
  useEffect(() => {
    const timer = setTimeout(() => {
      fetchData(searchTerm);
    }, 300);
    return () => clearTimeout(timer);
  }, [searchTerm, fetchData]);

  const handleSearchFocus = () => {
    if (searchTerm.trim()) {
      setIsDropdownVisible(true);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setIsDropdownVisible(e.target.value.trim().length > 0);
  };

  const handleClearSearch = () => {
    setSearchTerm("");
    setIsDropdownVisible(false);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".search-container")) {
        setIsDropdownVisible(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const handleViewClick = (id) => {
    setIsDropdownVisible(false); // Close the dropdown when clicking View
  };

  return (
    <div className="search-container position-relative ">
      <form
        className="app-search d-flex w-75 w-100"
        onSubmit={(e) => e.preventDefault()}
      >
        <div className="ms-sm-3 position-relative w-100">
          <Input
            type="text"
            className="form-control"
            placeholder="Search Trips"
            value={searchTerm}
            onChange={handleSearchChange}
            onFocus={handleSearchFocus}
          />
          <span className="mdi mdi-magnify search-widget-icon"></span>
          <div className="position-absolute top-50 translate-middle-y end-0 me-2">
            {searchTerm && (
              <button
                type="button"
                className="btn btn-link p-0 text-secondary border-0"
                onClick={handleClearSearch}
              >
                <i className="mdi mdi-close-circle"></i>
              </button>
            )}
          </div>
        </div>
      </form>

      {/* Responsive Dropdown */}
      {isDropdownVisible && searchResults.length > 0 && (
        <div className="position-absolute w-100 mt-1 search-dropdown">
          {/* Desktop View */}
          <div className="d-none d-md-block">
            <div
              className="dropdown-menu dropdown-menu-end dropdown-menu-xl card shadow-lg border-0 rounded-3 p-2"
              style={{
                right: 0,
                left: "auto",
              }}
            >
              <div
                className="overflow-auto"
                style={{ maxHeight: "400px", width: "100%" }}
              >
                {searchResults.map((item, index) => (
                  <SearchResultCard
                    key={index}
                    item={item}
                    onViewClick={handleViewClick}
                  />
                ))}
              </div>
            </div>
          </div>

          {/* Mobile View */}
          <div className="d-md-none">
            <div
              className="position-fixed start-0 end-0 bg-white shadow"
              style={{
                top: "60px",
                bottom: 0,
                zIndex: 1050,
                overflowY: "auto",
              }}
            >
              <div className="p-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="mb-0">Search Results</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setIsDropdownVisible(false)}
                  ></button>
                </div>
                {searchResults.map((item, index) => (
                  <SearchResultCard
                    key={index}
                    item={item}
                    onViewClick={handleViewClick}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchOption;

// import React, { useState, useEffect } from 'react';
// import { Input } from 'reactstrap'; // Assuming you're using reactstrap
// import { debounce } from 'lodash'; // Debouncing search
// import apiService from './apiService'; // Adjust the import to your API service

// const SearchOption = () => {
//     const [value, setValue] = useState(""); // Store search input value
//     const [searchResults, setSearchResults] = useState([]); // Store search results
//     const [loading, setLoading] = useState(false); // Show loading state

//     // API call function
//     const searchPackages = async (searchTerm) => {
//         if (!searchTerm) {
//             setSearchResults([]); // Clear results if search term is empty
//             return;
//         }

//         setLoading(true);
//         try {
//             const response = await apiService.get(`/packages?search=${searchTerm}`);
//             setSearchResults(response.data); // Set the results to the state
//         } catch (error) {
//             console.error("Error fetching search results", error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Debounced search function to prevent excessive API calls
//     const debouncedSearch = debounce((value) => {
//         searchPackages(value);
//     }, 500); // 500ms delay

//     // Update the value on input change
//     const onChangeData = (e) => {
//         const value = e.target.value;
//         setValue(value);
//         debouncedSearch(value); // Call the debounced function
//     };

//     return (
//         <React.Fragment>
//             <form className="app-search d-none d-md-block" style={{ width: "200px" }}>
//                 <div className="position-relative">
//                     <Input
//                         type="text"
//                         className="form-control"
//                         placeholder="Search..."
//                         id="search-options"
//                         value={value}
//                         onChange={onChangeData}
//                     />
//                     <span className="mdi mdi-magnify search-widget-icon"></span>
//                     <span
//                         className="mdi mdi-close-circle search-widget-icon search-widget-icon-close d-none"
//                         id="search-close-options"
//                     ></span>
//                 </div>
//             </form>

//             {/* Show loading indicator if needed */}
//             {loading && <div>Loading...</div>}

//             {/* Display search results */}
//             <div>
//                 {searchResults.length > 0 ? (
//                     <ul>
//                         {searchResults.map((pkg) => (
//                             <li key={pkg.id}>{pkg.name}</li> // Render package name (adjust as per your data)
//                         ))}
//                     </ul>
//                 ) : (
//                     <div>No results found.</div>
//                 )}
//             </div>
//         </React.Fragment>
//     );
// };

// export default SearchOption;
